// extracted by mini-css-extract-plugin
module.exports = {"loader_center":"Loader_loader_center__2509u","loader":"Loader_loader__CBSLP"};